import { BrandLogo } from "@/components/BrandLogo";
import { useSiteSettings } from "@/lib/siteSettings";
import { S } from "./summaryCopy";

// "Wer misst hier?": company identity and method, no personal name or photo.
// Impressum/Datenschutz are linked only once the legal pages are live.
export default function TrustBlock({ lang }) {
  const { legal_live } = useSiteSettings();
  const C = (S[lang] || S.de).trust;
  return (
    <section data-testid="trust-block" className="mt-8 rounded-2xl border bg-card p-5 text-base shadow-sm sm:p-6 print:hidden">
      <BrandLogo className="h-8" />
      <h2 className="mt-3 font-heading text-lg font-semibold">{C.title}</h2>
      <p className="mt-2 font-medium">{C.company}</p>
      <p className="mt-1">
        <a href="https://www.positivup.com" className="text-primary underline underline-offset-2">
          www.positivup.com
        </a>
      </p>
      <p className="mt-2 text-muted-foreground">{C.how}</p>
      {legal_live && (
        <div className="mt-3 flex gap-4 text-sm">
          <a href="/impressum" className="underline underline-offset-2 hover:text-primary">{C.imprint}</a>
          <a href="/datenschutz" className="underline underline-offset-2 hover:text-primary">{C.privacy}</a>
        </div>
      )}
    </section>
  );
}
